<div>
  <!-- agenda-archives.component.html -->
  <!-- Trois filtres à choix unique (un second toucher retire le filtre), puis une
       ligne par tâche archivée (maquette 04) : coche verte si faite, croix grise sinon,
       puce d'état datée du jour où elle s'est fermée, culture à côté. -->
  <vw-choice-selector class="mb-4 mt-5 block" variant="chips" [options]="filterOptions" [value]="filter"
    [deselectable]="true" [ariaLabel]="'calendar.filters.label' | translate" (valueChange)="selectFilter($event)"></vw-choice-selector>

  @for (task of tasks; track task.uid ?? $index) {
  <div class="mb-2.5 flex gap-3 rounded-card border border-vw-line bg-vw-surface px-4 py-3.5" data-test="archive-row"
    [attr.data-state]="task.taskState">
    <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-pill"
      [class]="isDone(task) ? 'bg-vw-surface-tint text-vw-primary-ink' : 'bg-vw-surface-sunk text-vw-muted'" aria-hidden="true">
      @if (isDone(task)) {
        <vw-check-icon class="block h-5 w-5" />
      } @else {
        <vw-close-icon class="block h-5 w-5" />
      }
    </span>
    <div class="min-w-0 flex-1">
      <p class="truncate text-body font-semibold text-vw-ink">{{ task.name | Label }}</p>
      <div class="mt-1.5 flex items-center gap-2">
        <span class="inline-flex shrink-0 whitespace-nowrap rounded-pill px-2 py-0.5 text-caption" data-test="archive-state"
          [class]="isDone(task) ? 'bg-vw-surface-tint text-vw-primary-ink' : 'bg-vw-surface-sunk text-vw-body'">
          @if (task.closedAt) {
            {{ 'agenda.states-on.' + stateKey(task) | translate: { date: task.closedAt | vwDate: 'day-month' } }}
          } @else {
            {{ 'agenda.states.' + stateKey(task) | translate }}
          }
        </span>
        @if (task.gardenTask?.cropLabel; as crop) {
          <span class="min-w-0 truncate text-body-s text-vw-muted">{{ crop }}</span>
        }
      </div>
    </div>
  </div>
  }

  @if (tasks.length < totalTasks) {
  <button type="button" data-test="archive-more" [disabled]="isLoadingMore" (click)="loadMoreTasks()"
    class="mx-auto mt-2 flex min-h-target items-center justify-center rounded-pill px-6 text-body-s font-semibold text-vw-primary disabled:opacity-60">
    {{ 'agenda.more' | translate }}
  </button>
  }

  <!-- Un filtre vide ne dit pas que les archives le sont. -->
  @if (tasksLoaded && tasks.length === 0) {
  <vw-agenda-empty [messageKey]="filter ? 'agenda.empty.archives-filter' : 'agenda.empty.archives'"></vw-agenda-empty>
  }

  <!-- Trois articles, puis « Voir tous » (A2) -->
  @if (!isLoading && articles.length > 0) {
  <div class="flex flex-col gap-4 mt-8 mb-28">
    <div class="flex items-baseline justify-between gap-3">
      <h2 class="text-title-l text-vw-ink">
        {{ "home.articles.title" | translate }}
      </h2>
      <button type="button" (click)="onAllArticles()" data-test="agenda-all-articles"
        class="min-h-target shrink-0 text-body-s font-semibold text-vw-primary">
        {{ 'articles.see-all' | translate }} &rsaquo;
      </button>
    </div>
    @for (article of articles; track article) {
    <vw-article [article]="article"></vw-article>
    }
  </div>
  }

</div>